import { ABOUT_US_CONSTANTS } from '../constants';

export function Footer(): JSX.Element {
  return (
    <div className="w-full bg-surface-0 border-t border-border-gray py-6 px-4">
      <div className="max-w-screen-xl mx-auto flex justify-center items-center">
        <div className="text-sm text-gray-600">
          &copy; {new Date().getFullYear()} BeautifulCode LLP. All rights
          reserved.
        </div>
        <div className="mx-3">|</div>
        <a
          href={ABOUT_US_CONSTANTS.LINKS.PRIVACY_POLICY}
          className="text-sm text-blue-600 hover:underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
      </div>
    </div>
  );
}
